<template>
  <div class="home">

    <span v-for="(lists, index) in playlists" :key="index" >
        <Playlist :playlist="lists"></Playlist>
    </span>


  </div>
</template>
<script src="https://sdk.scdn.co/spotify-player.js"></script>
<script>
// @ is an alias to /src
// BQD1W-4HborZTpxZQqji_6Hq7SZAjBGrx6BnvW5GznALrSJnpTH-LqY27bz9xpO3rDCxZIhWkk0KH92Bri7k433AKUS9hEdz1t5zDerVi89g9GcZ9g54QWXA49UMDAmr52Rpdnpy4qYmguqEoFE_3UZKUxEe5XUp
import Playlist from "@/components/Playlist"
import api from "@/api";
export default {
  data() {
    return {
      token: null,
      playlists: [],
      skus: ['7zKNhoAFp8sDSo8eyq8JuT','3q1bOoFgk5pulb08f0636N','6GXhq9lkbCvHq5DBkSfjwG'],
      obj: {},
    }
  },
  name: "Home",
  mounted() {
    this.token = api.getAuth().then((token) => {
      this.skus.forEach(element => {
        api.getPlaylist(token, element).then(response => {
        //console.log(`Response is ${JSON.stringify(response.data)}`);
        //this.obj = response.data;
        this.playlists.push(response.data)
      });
      });

    });
  },
  components: {
    Playlist
  }
};
</script>
<style scoped>
.home {
  max-width: 1280px;
}
</style>
